export default __webpack_public_path__ + "static/media/smarttravel.c12c55de.PNG";